import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';
import './utils/axiosConfig'; // Initialize axios interceptors
import { reloadOnceForNewVersion } from './utils/lazyWithReload';
import { initNativeApp } from './utils/native';

initNativeApp();

// Vite reports a failed preload of a page's files here (same cause: a deploy
// replaced them); reload once so the tab gets the new version.
window.addEventListener('vite:preloadError', (event) => {
  if (reloadOnceForNewVersion()) event.preventDefault();
});

// Sentry — no-op when REACT_APP_SENTRY_DSN is unset (dev / first boot before secret).
const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || 'production',
    release: process.env.REACT_APP_DEPLOY_VERSION,
    tracesSampleRate: 0.05,
    sendDefaultPii: false,
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);